import { render, staticRenderFns } from "./TasksKanban.vue?vue&type=template&id=4a238c5d&"
import script from "./TasksKanban.vue?vue&type=script&lang=js&"
export * from "./TasksKanban.vue?vue&type=script&lang=js&"
import style0 from "./TasksKanban.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports